'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import TechnologyFaq from '@/components/technologies/technology-faq';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import ShopifyFAQ from '@/components/faqs/shopify-faq';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import ShopifyEcommerce from '@/components/technologies/shopify-ecommerce';
import ShopifyServies from '@/components/technologies/shopify-demand';

import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHeroApp = dynamic(() => import('@/components/technologies/tech-hero-app'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroApp
                className=""
                desc="Create a Shopify store to empower your business online, connect with customers, and drive high conversions. Our Shopify website development services offer seamless customer engagement and tailored shopping experiences."
                alt="hero image"
                title="hero image"
                width={582}
                height={550}
                path={'shopify-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                Shopify <div>Development Company</div>
            </TechHeroApp>
            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="Shopify" />
            <ShopifyEcommerce title="Build A Next-Gen Shopify eCcommerce Store For A Distinctive Brand Presence"></ShopifyEcommerce>
            <ShopifyServies />
            <HireProcess
                bg="bg-shopify"
                pageTitle="Get Your Shopify Store Up and Running Today!"
                desc="Are you looking to develop your Shopify eCommerce store with its intuitive dashboard? Our Shopify developers can set up your store with customized features that will boost your sales."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For Shopify Application Development?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best Shopify Developers"
                desc="Shopify is the most popular hosting eCommerce platform used by more than 1 million eCommerce businesses globally. It's a self-hosted platform which means you don't need to worry about server, deployment, etc. The majority of things in that regard are managed by Shopify."
            />
            <TechnologyFaq title="FAQs On Shopify Website Development" bg="bg-shopify">
                <ShopifyFAQ />
            </TechnologyFaq>
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
